module.exports = __webpack_public_path__ + "static/media/closing-img.0fb927dc.png";